
import Vue from "vue";
import { NewTenantUsersApiFunc, setAccessToken } from "@/api";
import { TenantUser } from "@/models";

import BaseCloseButton from "@/components/BaseCloseButton.vue";
import BaseSubmitButton from "@/components/BaseSubmitButton.vue";
import BaseCancelButton from "@/components/BaseCancelButton.vue";
import TheTemplate from "../TheNoSidebarTemplate.vue";

export type DataType = {
  tenantUser?: TenantUser;
};

export default Vue.extend({
  name: "TenantUserDetailScreen",

  components: {
    TheTemplate,
    BaseCloseButton,
    BaseSubmitButton,
    BaseCancelButton,
  },

  data(): DataType {
    return {
      tenantUser: new TenantUser(),
    };
  },

  computed: {},

  mounted() {
    this.getTenantUser();
  },

  methods: {
    async getTenantUser(): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      const tenantUserId = this.$router.currentRoute.params.tenantUserId;
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewTenantUsersApiFunc().getTenantUser(
        companyId,
        tenantUserId
      );

      if (err != null) {
        this.$handleApiError(err, this.getTenantUser);
        return;
      }

      this.tenantUser = data;
    },

    async deleteTenantUser(): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      this.$setLoading(true);
      const tenantUserId = this.$router.currentRoute.params.tenantUserId;
      setAccessToken(this.$auth.accessToken);
      const { err } = await NewTenantUsersApiFunc().deleteTenantUser(
        companyId,
        tenantUserId
      );

      if (err != null) {
        this.$handleApiError(err, this.deleteTenantUser);
        this.$setLoading(false);
        return;
      }
      this.$setLoading(false);
      this.$setChecked(true);
      this.$afterSuccessRequest(() => {
        this.$router.push({
          name: "company-tenant-users",
          params: {
            updated: "true",
          },
        });
      }, 2);
    },

    afterLeave(): void {
      this.$setChecked(false);
    },
  },
});
